const TRIAL_PROMO_SUFFIX =
  "free trial • No credit card required • Cancel anytime";

const DEFAULT_TRIAL_DAYS = 14;

/**
 * @param {number | string | null | undefined} trialDays
 * @returns {number}
 */
export function resolveTrialDays(trialDays) {
  const parsed = Number(trialDays);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return DEFAULT_TRIAL_DAYS;
  }
  return Math.floor(parsed);
}

/**
 * Marketing line under pricing cards — only the day count is dynamic.
 * @param {number | string | null | undefined} trialDays
 */
export function buildTrialPromoText(trialDays) {
  const days = resolveTrialDays(trialDays);
  return `${days}-day ${TRIAL_PROMO_SUFFIX}`;
}

/**
 * Pricing section subtitle — only the day count is dynamic.
 * @param {number | string | null | undefined} trialDays
 */
export const PRICING_DESCRIPTION_LEAD =
  "Choose the right plan for your recruitment needs. All plans include a ";

export function buildPricingDescriptionTrialPhrase(trialDays) {
  const days = resolveTrialDays(trialDays);
  return `${days}-day free trial`;
}

export function buildPricingDescriptionText(trialDays) {
  return `${PRICING_DESCRIPTION_LEAD}${buildPricingDescriptionTrialPhrase(trialDays)}.`;
}

export { TRIAL_PROMO_SUFFIX, DEFAULT_TRIAL_DAYS };
